import { Switch } from "../../../components/Switch/Switch.tsx";
import { useUser } from "../../hooks/useUser.ts";
import { isUserAllowedTo } from "../../utils/isUserAllowedTo.ts";
import { debugModeStore } from "./stores/debugModeStore.ts";

export const DebugModeToggle = () => {
  const { isDebugModeOn } = debugModeStore.useState();

  const { user } = useUser();
  if (!(user && isUserAllowedTo(user, "mode:debug"))) return null;

  return (
    <div className="flex-row-center">
      <Switch
        value={isDebugModeOn}
        onChange={(value) => debugModeStore.setIsDebugMode(value)}
      />
    </div>
  );
};
